module.exports = __webpack_public_path__ + "img/download_galaxy_storeTW.fd973ce1.png";